// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1aIc-","checkboxCol":"Table_checkboxCol__Fqicw","emailCol":"Table_emailCol__2_Ot3","actionCol":"Table_actionCol__ZC5VW"};